import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { api } from '@pik/pik-utils';
import MapWidget from '@pik/pik6.0-map-widget';
import { MapContainer } from './styles';

const DEFAULT_VIEWPORT = {
  latitude: 55.76,
  longitude: 37.58,
  zoom: 15,
};

class CustomMap extends Component {
  state = {
    viewport: DEFAULT_VIEWPORT,
  };

  componentDidMount() {
    const { map } = this.props;

    this.setState({ viewport: map && map.viewport });
  }

  render() {
    const { map } = this.props;
    const { viewport } = this.state;

    if (map && Array.isArray(map.poiData) && map.poiData.length) {
      const { poiData } = map;

      const points = poiData.map((item) => ({
        longitude: item.latitude,
        latitude: item.longitude,
      }));

      return (
        <MapContainer>
          <MapWidget
            api={api}
            handlers={{
              onPointClick: this.onPointClick,
            }}
            placemarkHideInfo
            viewport={viewport}
            defaultViewport={DEFAULT_VIEWPORT}
            showControls
            points={points}
            isClustering={false}
            pointHideInfo
          />
        </MapContainer>
      );
    }

    return null;
  }
}

CustomMap.propTypes = {
  map: PropTypes.shape({
    poiData: PropTypes.arrayOf(PropTypes.shape({})),
    viewport: PropTypes.shape({}),
  }).isRequired,
};

export default CustomMap;
